export default __webpack_public_path__ + "images/5e1048c8e01f80a8c1c25d4e561bd57c-leaf-background.jpg";